import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "theme"];
var _templateObject;
var StyledTableData = styled('td')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: left;\n  vertical-align: top;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.table ? "\n    padding: ".concat(theme.table.cellPaddingTop, " ").concat(theme.table.cellPaddingRight, " ").concat(theme.table.cellPaddingBottom, " ").concat(theme.table.cellPaddingLeft, "\n    font-size: ").concat(theme.table.fontSize, "\n  ") : '';
});
var TableData = function TableData(_ref2) {
  var children = _ref2.children,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement(StyledTableData, _extends({
    theme: theme
  }, rest, {
    className: className,
    style: style
  }), children);
};
var _TableData = withDefaultTheme(/*#__PURE__*/memo(TableData));

export default _TableData;
